import {defineStore} from 'pinia'

const ttl = 1000 * 60 * 60 * 24; // 24 hours

export const useBannerStore = defineStore('BannerStore', {
    persist: true,
    state: () => {
        return {
            expiry: null
        }
    },

    actions: {
        hide () {
            let now = new Date()

            this.expiry = now.getTime() + ttl
        },

        show() {
            let now = new Date()

            if (this.expiry === null) {
                return true
            }

            if (now.getTime() > this.expiry) {
                this.expiry = null;

                return true
            }

            return false
        }
    }
})
